import { render } from "./AdsTypesSummaryWidget.vue?vue&type=template&id=4e6fdf8c&scoped=true&ts=true"
import script from "./AdsTypesSummaryWidget.vue?vue&type=script&lang=ts"
export * from "./AdsTypesSummaryWidget.vue?vue&type=script&lang=ts"

import "./AdsTypesSummaryWidget.vue?vue&type=style&index=0&id=4e6fdf8c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6fdf8c"]])

export default __exports__